var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStoreHours = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 3,
    d: "M24 12v12h10.5m6 0c0 9.114-7.388 16.5-16.5 16.5S7.5 33.114 7.5 24 14.888 7.5 24 7.5 40.5 14.886 40.5 24z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStoreHours);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/storeHours.05745386ae18c869b58e181f377de825.svg";